<template>
    <div>
        <el-page-header @back="goBack" content="三级标签管理"></el-page-header>
        <el-card class="form-container" shadow="never" style="margin-top: 10px">
            <div style="font-size: 18px; color: black;">商城三级标签修改及设置</div>
            <el-table border :data="subClassifyList"  :header-cell-style="{background:'#606266'}"  height="250" style="margin-top: 10px">
                <el-table-column label="id"   align="center" width="200px" >
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.id" v-if="scope.row.id==0 "></el-input-number>
                        <el-input v-model="scope.row.id" v-else :disabled="true"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="分类名称"  align="center" width="200px" >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.name"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="父节点" prop="parentId"  align="center" width="100px" >
                </el-table-column>
                <el-table-column label="分类排序"  align="center" width="220px">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.rank"></el-input-number>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 10px;left: 80% ;position:relative">
                <el-button size="mini" type="primary" @click="addClassify">新增条目</el-button>
                <el-button size="mini" type="success" @click="updateClassifyList">更新修改</el-button>
            </div>
        </el-card>
        <el-card class="form-container" shadow="never" style="margin-top: 10px">
            <el-form :inline="true"  size="small" label-width="140px">
                <el-form-item label="分类内商品排序设置：" label-width="180px" >
                    <el-select v-model="classifyId" placeholder="请选择"  >
                        <el-option v-for="classify in subClassifyList"
                                   :key="classify.id"
                                   :label="classify.name"
                                   :value="classify.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label=" " class="sub-sub11" >
                    <el-button type="primary" @click="queryShelves">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table border :data="shelvesList"  :header-cell-style="{background:'#606266'}"  height="330" style="margin-top: 10px">
                <el-table-column label="序号ID" prop="id" align="center"></el-table-column>
                <el-table-column label="商品名称" prop="name" align="center"></el-table-column>
                <el-table-column label="标签id" prop="classifyId" align="center"></el-table-column>
                <el-table-column label="当前价格" prop="currentPrice" align="center"></el-table-column>
                <el-table-column label="商品排序" prop="rank" align="center"></el-table-column>
                <el-table-column label="操作"  align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="getTopMove(scope.row,scope.$index)" :disabled="scope.$index==0">
                            置顶
                        </el-button>
                        <el-button type="text" size="small" @click="getUpMove(scope.row,scope.$index)" :disabled="scope.$index==0">
                            上移
                        </el-button>
                        <el-button type="text" size="small" @click="getDownMove(scope.row,scope.$index)"
                                   :disabled="shelvesList.length-1==scope.$index">下移
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

        </el-card>
    </div>
</template>

<script>
    import {
        shopSelections,
        classifyUpdate,
        shelvesListByClassifyId,
        updateShelvesRank,
        subClassifySelections
    } from "@/http/iosBookApi";
    export default {
        name: "BookThirdhelvesManage",
        data(){
            return{
                subClassifyList:[],
                classifyId : this.$route.query.classifyId,
                parentId : this.$route.query.classifyId,
                jumpParentId : this.$route.query.parentId,
                shelvesList :[]
            }
        },
        methods:{
            goBack() {
                // console.log(this.parentId)
                this.$router.push({ path: '/bookSubShelvesManage',query:{classifyId:this.jumpParentId}});
            },
            getSelections(){
                console.log(this.parentId)
                subClassifySelections(this.parentId).then(resp => {
                    // console.log(resp.data.info)
                    this.subClassifyList = resp.data.info.classifyList;
                    if(this.subClassifyList.length>0){
                        this.classifyId=this.subClassifyList[0].id
                        this.parentId=this.subClassifyList[0].parentId
                        this.queryShelves()
                    }
                })
            },
            updateClassifyList(){
                classifyUpdate(this.subClassifyList).then(resp => {
                    if (resp.data.status === 0){
                        this.getSelections();
                    }
                })
            },
            queryShelves(){
                shelvesListByClassifyId(this.classifyId).then(resp => {
                    this.shelvesList = resp.data.info
              })
            },
            getTopMove(row, index) {
                this.shelvesList.splice(index, 1);
                this.shelvesList.unshift(row)
                this.batchUpdateRank()
            },
            //上移
            getUpMove(row, index) {
                let arr = this.shelvesList;
                arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]));
                this.batchUpdateRank()
                },
            //下移
            getDownMove(row, index) {
                let arr = this.shelvesList;
                arr.splice(index, 1, ...arr.splice(index + 1, 1, arr[index]));
                this.batchUpdateRank()
                },
            batchUpdateRank(){
                updateShelvesRank(this.shelvesList).then(resp => {
                    if (resp.data.status === 0){
                        this.queryShelves();
                    }
                })
            },
            addClassify(){
                let arr = this.subClassifyList;
                arr.push({id:0,name:"",rank:0,parentId:this.parentId})
            }
         },
        created() {
            this.getSelections();
        },

    }
</script>

<style scoped>

</style>
